import React from 'react';
import { MapPin, Phone, Mail, Facebook, Clock } from 'lucide-react';
import { contactInfo } from '../mock';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent">
              Kontakt
            </span>
          </h2>
          <p className="text-xl text-gray-600">
            Wir sind für Sie da – kontaktieren Sie uns jederzeit!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl p-8 border-2 border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Kontaktinformationen</h3>
              
              <div className="space-y-6">
                {/* Address */}
                <div className="flex items-start space-x-4">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <MapPin className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Adresse</h4>
                    <p className="text-gray-700">
                      {contactInfo.address}<br />
                      {contactInfo.postalCode} {contactInfo.city}
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start space-x-4">
                  <div className="bg-orange-600 p-3 rounded-lg">
                    <Phone className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Telefon</h4>
                    <a
                      href={`tel:${contactInfo.phone}`}
                      className="text-blue-600 hover:text-blue-700 font-medium text-lg"
                    >
                      {contactInfo.phone}
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start space-x-4">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <Mail className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">E-Mail</h4>
                    <a
                      href={`mailto:${contactInfo.email}`}
                      className="text-blue-600 hover:text-blue-700 font-medium"
                    >
                      {contactInfo.email}
                    </a>
                  </div>
                </div>

                {/* Facebook */}
                <div className="flex items-start space-x-4">
                  <div className="bg-orange-600 p-3 rounded-lg">
                    <Facebook className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Facebook</h4>
                    <a
                      href={`https://facebook.com/${contactInfo.facebook}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 font-medium"
                    >
                      {contactInfo.facebook}
                    </a>
                  </div>
                </div>

                {/* Opening Hours */}
                <div className="flex items-start space-x-4">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <Clock className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Verfügbarkeit</h4>
                    <p className="text-gray-700">
                      <span className="font-semibold text-red-600">24/7 Notdienst</span><br />
                      Reguläre Buchungen: Mo-So, 08:00-18:00 Uhr
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Contact Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={`tel:${contactInfo.phone}`}
                className="flex-1 flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              >
                <Phone className="h-5 w-5" />
                <span>Anrufen</span>
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex-1 flex items-center justify-center space-x-2 bg-gradient-to-r from-orange-600 to-orange-700 text-white px-6 py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              >
                <Mail className="h-5 w-5" />
                <span>E-Mail</span>
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-2xl border-2 border-gray-200 h-[600px]">
            <iframe
              src={`https://www.google.com/maps?q=${contactInfo.coordinates.lat},${contactInfo.coordinates.lng}&hl=de&z=15&output=embed`}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Maps"
            ></iframe>
          </div>
        </div>

        {/* Emergency Notice */}
        <div className="mt-12 bg-gradient-to-r from-red-500 to-red-600 rounded-2xl p-8 text-white text-center">
          <Phone className="h-12 w-12 mx-auto mb-4" />
          <h3 className="text-3xl font-bold mb-3">24/7 Notfall-Service</h3>
          <p className="text-lg mb-4">
            Im Notfall sind wir rund um die Uhr für Sie und Ihr Tier da!
          </p>
          <a
            href={`tel:${contactInfo.phone}`}
            className="inline-block bg-white text-red-600 px-8 py-4 rounded-xl font-bold text-xl hover:bg-gray-100 transition-colors"
          >
            {contactInfo.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
